
import axios from '../config/axios';

export const url = '/api/eventodelanzamiento9x482'


export const createeventodelanzamiento9x482 = ({
  token,
	nombrecompletoee9bo,
	correovfciv,
	telefonodawc7g,
	intitucionb7o3h,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombrecompletoee9bo && correovfciv && telefonodawc7g && intitucionb7o3h ) {

    axios.post(`${url}//create/basic/691d13b3e3072492500798b9`, {
		nombrecompletoee9bo,
		correovfciv,
		telefonodawc7g,
		intitucionb7o3h,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombrecompletoee9bo) {
		reject({
			status: 'error',
			info: 'Nombre completo no esta definido',
		});
	}  else if (!correovfciv) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else if (!telefonodawc7g) {
		reject({
			status: 'error',
			info: 'Telefono no esta definido',
		});
	}  else if (!intitucionb7o3h) {
		reject({
			status: 'error',
			info: 'Intitucion no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

